export default {
  foodMerchantCategories: [],
};
